// Imports for external libraries go here.
import React, { FC } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { StepperProps } from './Stepper.types';
import { StyledStepper } from './Stepper.styles';
import clsx from 'clsx';

// Use named rather than default exports.
export const Stepper: FC<StepperProps> = ({
  stepperText,
  handleDecrement,
  handleIncrement,
  disableIncrement,
  disableDecrement,
  analyticsVal,
  increamentLabel,
  decreamentLabel,
  variation = 'default', // Stepper has 'default' variation by default
}) => {
  return (
    <StyledStepper data-component-name="m-ui-library-Stepper" data-testid="ui-library-Stepper">
      {variation === 'default' && (
        <div className="m-stepper-wrapper">
          <div className="m-stepper">
            <div className="disable-hover">
              <button
                type="button"
                className={clsx('custom_click_track', disableDecrement && 'btn-disable')}
                {...{ custom_click_track_value: `${analyticsVal} Decrement button |internal` }}
                aria-disabled={disableDecrement}
                data-testid="remove-btn"
                tabIndex={disableDecrement ? -1 : 0}
                onClick={handleDecrement}
              >
                <span aria-hidden="true" className="icon-minus"></span>
                <span className="sr-only">{decreamentLabel}</span>
              </button>
            </div>
            <span aria-live="polite">{stepperText}</span>
            <div className="disable-hover">
              <button
                type="button"
                className={clsx('custom_click_track', disableIncrement && 'btn-disable')}
                {...{ custom_click_track_value: `${analyticsVal} Increment button |internal` }}
                aria-disabled={disableIncrement}
                data-testid="add-btn"
                tabIndex={disableIncrement ? -1 : 0}
                onClick={handleIncrement}
              >
                <span aria-hidden="true" className="icon-plus"></span>
                <span className="sr-only">{increamentLabel}</span>
              </button>
            </div>
          </div>
        </div>
      )}
      {variation === 'bordered' && (
        <div className="m-stepper-wrapper-square">
          <div className="m-stepper-square">
            <div
              className={clsx(
                'disable-hover d-flex justify-content-center decrement-btn',
                !disableDecrement ? 'active-decrement' : 'disable-decrement'
              )}
            >
              <button
                type="button"
                className={clsx('custom_click_track w-100 align-items-center', disableDecrement && 'btn-disable')}
                {...{ custom_click_track_value: `${analyticsVal} Decrement button |internal` }}
                aria-disabled={disableDecrement}
                data-testid="remove-btn"
                tabIndex={disableDecrement ? -1 : 0}
                onClick={!disableDecrement ? handleDecrement : undefined}
              >
                <span aria-hidden="true" className="icon-minus"></span>
                <span className="sr-only">{decreamentLabel}</span>
              </button>
            </div>
            <span
              aria-live="polite"
              className="d-flex align-items-center justify-content-center flex-grow-1 h-100 text-center text-nowrap counter"
            >
              {stepperText}
            </span>
            <div
              className={clsx(
                'disable-hover d-flex justify-content-center increment-btn flex-shrink-0',
                !disableIncrement ? 'active-increment' : 'disable-increment'
              )}
            >
              <button
                type="button"
                className={clsx('custom_click_track w-100 align-items-center', disableIncrement && 'btn-disable')}
                {...{ custom_click_track_value: `${analyticsVal} Increment button |internal` }}
                aria-disabled={disableIncrement}
                data-testid="add-btn"
                tabIndex={disableIncrement ? -1 : 0}
                onClick={!disableIncrement ? handleIncrement : undefined}
              >
                <span aria-hidden="true" className="icon-plus"></span>
                <span className="sr-only">{increamentLabel}</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </StyledStepper>
  );
};
